import { Fragment } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import Select from 'react-select';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';
import type { DefensoriaOption } from './relatorio-civel-step-props';

export default function Step15DesignacaoEspecialAudiencias(props: RelatorioCivelStepProps) {
  const {
    novaAudienciaDesig,
    setNovaAudienciaDesig,
    novoNumeroProcessoDesigAud,
    setNovoNumeroProcessoDesigAud,
    apenasNumeros,
    novaDataDesigAud,
    setNovaDataDesigAud,
    defensoriasOptions,
    novaDefensoriaIdDesigAud,
    setNovaDefensoriaIdDesigAud,
    adicionarDesignacaoEspecialAudiencia,
    isViewMode,
    setQuantidadeLinhas,
    quantidadeLinhas,
    adicionarMultiplasLinhasDesignacaoEspecialAudiencias,
    formData,
    editandoDesignacaoEspecialAudiencia,
    valorEdicaoAudienciaDesig,
    setValorEdicaoAudienciaDesig,
    valorEdicaoNumeroProcessoDesigAud,
    setValorEdicaoNumeroProcessoDesigAud,
    valorEdicaoDataDesigAud,
    setValorEdicaoDataDesigAud,
    valorEdicaoDefensoriaIdDesigAud,
    setValorEdicaoDefensoriaIdDesigAud,
    getDefensoriaLabel,
    formatarDataHelper,
    salvarEdicaoDesignacaoEspecialAudiencia,
    cancelarEdicaoDesignacaoEspecialAudiencia,
    iniciarEdicaoDesignacaoEspecialAudiencia,
    removerDesignacaoEspecialAudiencia,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold">Tipo de peça</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex: Audiência de Instrução"
                value={novaAudienciaDesig}
                onChange={(e) => setNovaAudienciaDesig(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex: 000000.000.000"
                value={novoNumeroProcessoDesigAud}
                onChange={(e) => setNovoNumeroProcessoDesigAud(apenasNumeros(e.target.value))}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Data</Form.Label>
              <Form.Control
                type="date"
                value={novaDataDesigAud}
                onChange={(e) => setNovaDataDesigAud(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="fw-bold">Defensoria do Processo/Vara</Form.Label>
              <Select
                inputId="defensoriaProcessoVaraAud"
                options={defensoriasOptions}
                isClearable
                placeholder="Selecione..."
                value={
                  novaDefensoriaIdDesigAud
                    ? defensoriasOptions.find((o) => o.value === novaDefensoriaIdDesigAud)
                    : null
                }
                onChange={(opt) => setNovaDefensoriaIdDesigAud((opt as DefensoriaOption | null)?.value ?? null)}
              />
            </Form.Group>
          </Col>
          <Col md={1} className="d-flex align-items-end">
            <Button
              variant="primary"
              onClick={adicionarDesignacaoEspecialAudiencia}
              style={{ borderRadius: '8px' }}
              className="w-100"
              disabled={isViewMode}
            >
              <i className="bi bi-plus-lg me-2"></i>
              Adicionar
            </Button>
          </Col>
        </Row>
      )}

      <Row className="mb-3">
        {!isViewMode && (
          <Col md={6}>
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted">Adicionar</span>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    designacaoEspecialAudiencias: Math.max(1, prev.designacaoEspecialAudiencias - 1),
                  }))
                }
                style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
              >
                <i className="bi bi-dash">-</i>
              </Button>
              <Form.Control
                type="number"
                min="1"
                max="50"
                value={quantidadeLinhas.designacaoEspecialAudiencias}
                onChange={(e) =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    designacaoEspecialAudiencias: Math.max(1, parseInt(e.target.value) || 1),
                  }))
                }
                style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                size="sm"
              />
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() =>
                  setQuantidadeLinhas((prev) => ({
                    ...prev,
                    designacaoEspecialAudiencias: Math.min(50, prev.designacaoEspecialAudiencias + 1),
                  }))
                }
                style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
              >
                <i className="bi bi-plus">+</i>
              </Button>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={adicionarMultiplasLinhasDesignacaoEspecialAudiencias}
                style={{ borderRadius: '8px' }}
              >
                <i className="bi bi-plus-lg me-1"></i>
                Adicionar {quantidadeLinhas.designacaoEspecialAudiencias} linha
                {quantidadeLinhas.designacaoEspecialAudiencias > 1 ? 's' : ''}
              </Button>
            </div>
          </Col>
        )}
        <Col md={isViewMode ? 12 : 6} className="d-flex align-items-center justify-content-end">
          <h5 className="mb-0 text-primary">
            <small className="text-muted">Total de Itens:</small> {formData.designacaoEspecialAudiencias.itens.length}
          </h5>
        </Col>
      </Row>

      <Table bordered hover>
        <thead className="table-light">
          <tr>
            <th style={{ width: '5%' }}>#</th>
            <th style={{ width: '20%' }}>Audiência</th>
            <th style={{ width: '20%' }}>N.º do Processo</th>
            <th style={{ width: '15%' }}>Data</th>
            <th style={{ width: '20%' }}>Defensoria do Processo/Vara</th>
            {!isViewMode && <th style={{ width: '20%' }}>Ações</th>}
          </tr>
        </thead>
        <tbody>
          {formData.designacaoEspecialAudiencias.itens.length === 0 ? (
            <tr>
              <td colSpan={isViewMode ? 5 : 6} className="text-center text-muted">
                Nenhum item adicionado ainda
              </td>
            </tr>
          ) : (
            formData.designacaoEspecialAudiencias.itens.map((item, index: number) => {
              const estaEditando = editandoDesignacaoEspecialAudiencia === item.id;

              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Ex: Audiência de Instrução"
                        value={valorEdicaoAudienciaDesig}
                        onChange={(e) => setValorEdicaoAudienciaDesig(e.target.value)}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      item.audiencia
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Ex: 000000.000.000"
                        value={valorEdicaoNumeroProcessoDesigAud}
                        onChange={(e) => setValorEdicaoNumeroProcessoDesigAud(apenasNumeros(e.target.value))}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                            e.preventDefault();
                          }
                        }}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      item.numeroProcesso
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <Form.Control
                        type="date"
                        size="sm"
                        value={valorEdicaoDataDesigAud}
                        onChange={(e) => setValorEdicaoDataDesigAud(e.target.value)}
                        style={{ borderRadius: '8px' }}
                      />
                    ) : (
                      formatarDataHelper(item.data)
                    )}
                  </td>
                  <td>
                    {estaEditando ? (
                      <Select
                        inputId={`defensoriaProcessoVaraAud-${item.id}`}
                        options={defensoriasOptions}
                        isClearable
                        placeholder="Selecione..."
                        value={
                          valorEdicaoDefensoriaIdDesigAud
                            ? defensoriasOptions.find((o) => o.value === valorEdicaoDefensoriaIdDesigAud)
                            : null
                        }
                        onChange={(opt) => setValorEdicaoDefensoriaIdDesigAud((opt as DefensoriaOption | null)?.value ?? null)}
                      />
                    ) : (
                      item.defensoriaLabel || getDefensoriaLabel(item.defensoriaId)
                    )}
                  </td>
                  {!isViewMode && (
                    <td>
                      {estaEditando ? (
                        <div className="d-flex gap-1">
                          <Button
                            style={{ width: '80px', height: '40px' }}
                            variant="success"
                            size="sm"
                            onClick={() => salvarEdicaoDesignacaoEspecialAudiencia(item.id)}
                            title="Salvar"
                          >
                            <i className="bi bi-check-lg"> Salvar</i>
                          </Button>
                          <Button
                            style={{ width: '80px', height: '40px' }}
                            variant="secondary"
                            size="sm"
                            onClick={cancelarEdicaoDesignacaoEspecialAudiencia}
                            title="Cancelar"
                          >
                            <i className="bi bi-x-lg"> Cancelar</i>
                          </Button>
                        </div>
                      ) : (
                        <div className="d-flex gap-1">
                          <Button
                            style={{ width: '80px', height: '40px' }}
                            variant="outline-primary"
                            size="sm"
                            onClick={() => iniciarEdicaoDesignacaoEspecialAudiencia(item)}
                            title="Editar"
                          >
                            <i className="bi bi-pencil"> Editar</i>
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => removerDesignacaoEspecialAudiencia(item.id)}
                            style={{ width: '80px', height: '40px' }}
                            title="Excluir"
                          >
                            <i className="bi bi-trash"> Excluir</i>
                          </Button>
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </Fragment>
  );
}

